// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: false,
  BASEURL: 'https://api.cq7pbmgz94-carlislec1-d1-public.model-t.cc.commerce.ondemand.com',
  internalSSO: "https://accstorefront.cq7pbmgz94-carlislec1-d1-public.model-t.cc.commerce.ondemand.com/samlsinglesignon/saml2/authenticate/internal-id",
  externalSSO: "https://accstorefront.cq7pbmgz94-carlislec1-d1-public.model-t.cc.commerce.ondemand.com/samlsinglesignon/saml2/authenticate/external-id",
  PREFIX: '/occ/v2/',
  BASE_SITE: ['carlisle-sales', 'carlisle-sales-ca'],
  ORIGIN: 'api.cq7pbmgz94-carlislec1-d1-public.model-t.cc.commerce.ondemand.com',
  COUNTRY: ['us', 'ca'],
  gtmId: 'GTM-MKJV7MS',
  auth0: {
    domain: 'auth-dev.carlisle.com',
    clientId: 'dYyrC8K8NvS07RGLmy9oU0ezhYKGmMIM',
    audience: 'https://api-dev.carlisle.com/commerce',
    // Must be the Auth0 callback URL (where Auth0 redirects after login). Add this URL in Auth0 Dashboard → Application → Allowed Callback URLs.
    redirectUri: '/auth0/callback',
    logoutUrl: '/carlisle-sales/USD/logout',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */

// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
